import * as i0 from '@angular/core';
import { Injectable, NgModule } from '@angular/core';
import { facadeFactory, provideDefaultConfigFactory, UserProfileFacadeTransitionalToken } from '@spartacus/core';
import { LAUNCH_CALLER } from '@spartacus/storefront';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const USER_PROFILE_FEATURE = 'userProfile';
const USER_PROFILE_CORE_FEATURE = 'userProfileCore';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let UserProfileFacade = /*#__PURE__*/(() => {
  class UserProfileFacade {
    static {
      this.ɵfac = function UserProfileFacade_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UserProfileFacade)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: UserProfileFacade,
        factory: () => (() => facadeFactory({
          facade: UserProfileFacade,
          feature: USER_PROFILE_CORE_FEATURE,
          methods: ['get', 'update', 'close', 'getTitles']
        }))(),
        providedIn: 'root'
      });
    }
  }
  return UserProfileFacade;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
// TODO: Inline this factory when we start releasing Ivy compiled libraries
function defaultUserProfileComponentsConfig() {
  const config = {
    featureModules: {
      [USER_PROFILE_FEATURE]: {
        cmsComponents: ['RegisterCustomerComponent', 'UpdateProfileComponent', 'UpdateEmailComponent', 'UpdatePasswordComponent', 'ForgotPasswordComponent', 'ResetPasswordComponent', 'CloseAccountComponent', 'AccountAddressBookComponent', 'RegisterCustomerWithOTPComponent', 'VerifyOTPForRegistrationComponent']
      },
      // by default core is bundled together with components
      [USER_PROFILE_CORE_FEATURE]: USER_PROFILE_FEATURE
    }
  };
  return config;
}
let UserProfileRootModule = /*#__PURE__*/(() => {
  class UserProfileRootModule {
    static {
      this.ɵfac = function UserProfileRootModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UserProfileRootModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: UserProfileRootModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfigFactory(defaultUserProfileComponentsConfig), {
          provide: UserProfileFacadeTransitionalToken,
          useExisting: UserProfileFacade
        }]
      });
    }
  }
  return UserProfileRootModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let UserEmailFacade = /*#__PURE__*/(() => {
  class UserEmailFacade {
    static {
      this.ɵfac = function UserEmailFacade_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UserEmailFacade)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: UserEmailFacade,
        factory: () => (() => facadeFactory({
          facade: UserEmailFacade,
          feature: USER_PROFILE_CORE_FEATURE,
          methods: ['update']
        }))(),
        providedIn: 'root'
      });
    }
  }
  return UserEmailFacade;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let UserPasswordFacade = /*#__PURE__*/(() => {
  class UserPasswordFacade {
    static {
      this.ɵfac = function UserPasswordFacade_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UserPasswordFacade)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: UserPasswordFacade,
        factory: () => (() => facadeFactory({
          facade: UserPasswordFacade,
          feature: USER_PROFILE_CORE_FEATURE,
          methods: ['update', 'reset', 'requestForgotPasswordEmail']
        }))(),
        providedIn: 'root'
      });
    }
  }
  return UserPasswordFacade;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let UserRegisterFacade = /*#__PURE__*/(() => {
  class UserRegisterFacade {
    static {
      this.ɵfac = function UserRegisterFacade_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UserRegisterFacade)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: UserRegisterFacade,
        factory: () => (() => facadeFactory({
          facade: UserRegisterFacade,
          feature: USER_PROFILE_CORE_FEATURE,
          methods: ['register', 'registerGuest', 'getTitles']
        }))(),
        providedIn: 'root'
      });
    }
  }
  return UserRegisterFacade;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
LAUNCH_CALLER['CLOSE_ACCOUNT'] = 'CLOSE_ACCOUNT';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/** AUGMENTABLE_TYPES_END */

/**
 * Generated bundle index. Do not edit.
 */

export { USER_PROFILE_CORE_FEATURE, USER_PROFILE_FEATURE, UserEmailFacade, UserPasswordFacade, UserProfileFacade, UserProfileRootModule, UserRegisterFacade, defaultUserProfileComponentsConfig };
